import { FunctionComponent } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Styles from "./Dropdown.module.css";

type props = {
  title?: string;
  option?: any[];
  setDetails?: () => void;
  setSelectedValue: (val: any) => any;
  selectedValue?: any;
  disable?: boolean;
  choices?: any[];
  isMulti?: boolean;
  style?: any;
};

const animatedComponents = makeAnimated();

const Dropdown: FunctionComponent<props> = ({
  title,
  option,
  setDetails,
  selectedValue,
  setSelectedValue,
  disable,
  choices,
  isMulti,
  style,
}) => {

  /**
   * Prepares options list for react-select
   * Priority:
   * 1. If `option` exists → transform it into dropdown options
   * 2. If no `option`, fallback to `choices`
   */
  const choice = () => {
    if (option) {
      const data = option.map((item: any, index: number) => {
        return (

          // Special label replacement for Team Lead → Team Leader
          item === "Team Lead"
            ? {
              value: item,
              label: "Team Leader",
            }
            : { value: item, label: item }
        )
      });

      // If title exists, push it as an extra option
      if (title) {
        data.push({ label: title, value: title });

        return data;
      } else {

        return data;
      }
    } else {

      // Fallback to choices if provided
      return choices ? choices : [];
    }
  };

  return (
    <>
      <Select
        className={Styles.select}
        menuPlacement="auto"
        maxMenuHeight={150}
        options={choice()}
        value={selectedValue}
        components={animatedComponents}
        onChange={(data) => {

          // When special title option is selected
          if (data?.label === title) {
            if (setDetails) setDetails();
          }
          setSelectedValue(data);
        }}
        showCheckbox={true}
        isSearchable={true}
        isDisabled={disable ? true : choice().length === 0 ? true : false}
        isMulti={isMulti}
        styles={style} // react-select uses **styles**, not "style"
      />
    </>
  );
};

export default Dropdown;
